<template>
  <v-container>
    <v-row>
      <v-col
          md="12"><h4>Add next round for a class</h4>
      </v-col>
    </v-row>
    <v-row>
      <v-col md="3">
        <v-overflow-btn
            v-model="classNameFilter"
            label="Class"
            :items="uniqueClassNames"
        ></v-overflow-btn>
      </v-col>
    </v-row>

    <v-row v-for="(round) in $store.state.rounds" v-bind:key="round.number">
      <v-col md="1">{{ round.number }}</v-col>
      <v-col md="2" ><span class="statusLabel" v-bind:class="{'completeRound':roundStatus(round)==='Complete','notStarted':roundStatus(round)==='Not started'}">{{ roundStatus(round) }}</span></v-col>
      <v-col md="1"><v-btn
          elevation="2"
          v-on:click="updateStandings(round)"
      >update standings
      </v-btn></v-col>
    </v-row>
    <v-row>
      <v-col md="3">
      <v-btn
          color="primary"
          elevation="2"
          v-on:click="createNextRound()"
      >Add next round
      </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {rounds} from "@/utils/rounds"
import {teams} from "@/utils/teams";

export default {

  data: () => ({
    classNameFilter: "Optimist",
    roundFilter: ""
  }),
  methods: {
    createNextRound: function () {
      if (this.classNameFilter === "") {
        alert("Select a class for the round you wish to create.")
        return false;
      }
      if(this.$store.state.event.roundRobin){
        rounds.getRoundRobin(this.$store, this.classNameFilter)
      } else {
        rounds.getMatchUps(this.$store, this.classNameFilter)
      }
      //
      this.$forceUpdate()
    },
    roundStatus(round) {
      let raceCount = 0;
      round.races.forEach((race) => race.result ? raceCount++ : null)
      if(raceCount===0){
        return "Not started"
      }
      if(raceCount<round.races.length){
        return "In progress"
      }
      return "Complete"
    },
    updateStandings : function(round){
        teams.updateStandings(this.$store,round);
    }
  },

  computed: {
    uniqueClassNames: teams.uniqueClassNames,
  }
}
</script>

<style>
.statusLabel {
  padding: 5px;
  border-radius: 10px;
  background-color: goldenrod;
  color:white;
}
.completeRound{
  background-color: green;
}
.notStarted{
  background-color: orangered;
}

</style>